/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "facebook-7e232b84--sprite",
  "use": "facebook-7e232b84--sprite-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"facebook-7e232b84--sprite\"><path d=\"M13.49 21.016v-8.667h2.95l.44-3.378h-3.39V6.815c0-.978.276-1.644 1.697-1.644L17 5.17V2.149a24.615 24.615 0 00-2.641-.133c-2.614 0-4.403 1.574-4.403 4.465v2.49H7v3.378h2.956v8.667h3.535z\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
